class Commodity {
	constructor(obj) {
		if (obj) {
			this.commodity_id = obj?.commodity_id
			this.commodity_name = obj?.commodity_name
			this.commodity_type = obj?.commodity_type
			this.brands = obj?.brands ?? []
		} else {
			this.commodity_id = 'COtx2Px-1001'
			this.commodity_name = 'MILD STEEL'
			this.commodity_type = 'FERROUS'
			this.brands = null //list
		}
	}
}

export default Commodity
